<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Add {{ $t('Client') }}</h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <form>
          <div class="panel panel-grey">
            <div class="panel-body">
              <div class="form-horizontal">
                <create-user ref="createUser" />
                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.company" v-bind:field-name="$t('organisation') | sentenceCase"/>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.position" field-name="Job Title" :show-required="$showDepartmentField"/>
                  </div>
                </div>

                <div class="row" v-if="$showDepartmentField">
                  <div class="col-md-12 col-lg-6">
                    <department-selection :model="$v.department"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <ladda-button
                class="btn btn-sm btn-primary"
                type="submit"
                :click="handleAddClientCallback">
                Add {{ $t('Client') }}
              </ladda-button>

              <div class="checkbox checkbox-primary pull-right" v-if="$vlastMode && $userIsAdmin">
                <input
                  type="checkbox"
                  name="send_activation_email"
                  id="send_activation_email"
                  v-model="$v.send_activation_email.$model"
                  />

                <label for="send_activation_email">
                  Send Activation Email To Client
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import { http, notify } from 'utils'
import DepartmentSelection from '../misc/DepartmentSelection'
import { requiredIf } from 'vuelidate/lib/validators'
import FieldInput from '../misc/FieldInput'
import CreateUser from '../CreateUser'

export default {
  components: {
    CreateUser,
    FieldInput,
    VueTelInput,
    DepartmentSelection
  },

  data () {
    return {
      company: null,
      position: null,
      send_activation_email: false
    }
  },

  validations: {
    company: {
      required: requiredIf(function (model) {
        return this.$showDepartmentField
      })
    },
    position: {
      required: requiredIf(function (model) {
        return this.$showDepartmentField
      })
    },
    department: {
      required: requiredIf(function (model) {
        return this.$showDepartmentField
      })
    },
    send_activation_email: {}
  },

  methods: {
    handleAddClientCallback () {
      if (this.$refs.createUser.invalid || this.$v.$invalid) {
        this.$v.$touch()
        this.$refs.createUser.validate()
        notify.error('Some fields are invalid. Please check and try again.')
        return Promise.resolve()
      }

      const payload = {
        ...this.$refs.createUser.payload,
        company: this.company,
        position: this.position,
        department_id: this.department,
        send_activation_email: this.send_activation_email
      }

      return http.post(`clients`, payload)
        .then((response) => {
          this.$router.push({ name: 'clients.profile.show', params: { id: response.data.id } })
        })
        .catch(() => {
          notify.error('Something went wrong. Please check your input and try again.')
        })
    }
  }
}
</script>
